export default __webpack_public_path__ + "static/media/hotel_background.4106ea0b.png";